import { useCallback, useContext, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { isEmailCapturePageExperimentV2InControlGroup, PAGE_ROUTES, useFlags } from '@lyrahealth-inc/shared-app-logic'
import { ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform'

export const useShowEmailCapturePageExperimentV2 = () => {
  const { emailCapturePageExperimentV2 } = useFlags()
  const { isLyraSelect } = useContext(ProductTypeContext)
  const { pathname } = useLocation()

  const isV2PathForLyraSelect = useCallback(() => {
    return [PAGE_ROUTES.REGISTER, PAGE_ROUTES.REGISTER_VERIFY].some((path) => pathname.startsWith(path))
  }, [pathname])

  const showEmailCapturePageExperimentV2 = useMemo(() => {
    return isLyraSelect
      ? isV2PathForLyraSelect()
      : !!emailCapturePageExperimentV2 && !isEmailCapturePageExperimentV2InControlGroup(emailCapturePageExperimentV2)
  }, [emailCapturePageExperimentV2, isLyraSelect, isV2PathForLyraSelect])

  return { showEmailCapturePageExperimentV2, emailCapturePageExperimentV2 }
}
